module.exports = __webpack_public_path__ + "static/1336363998.e5b2fa21.jpg";